/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/promise-function-async */
import React from 'react';
import { translateKeyLang } from '../../../../common/src/translate/translateHelper';
import { fetchGet, fetchPost } from '../../store/fetch';
import { Roles } from '../../utils/enums/Roles';
import { appContext } from '../appContext';
import { IconEditButton } from '../common/iconButtons/IconEditButton';
import {
    Content,
    EditPanelButton,
    EditPanelButtons,
    EditPanelCell,
    EditPanelInput,
    EditPanelRow,
    EditPanelSection,
    Panel,
    PanelBody,
    PanelBodyHeading,
    PanelRouterLink,
    PopupElement,
    RightTray,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    TopbarCrumbActive,
    TopbarLeftOnly,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';
import { Component } from '../utils/Component';

type ObjectTypeUnit = {
    id?: undefined | string;
    name?: undefined | string;
    code?: undefined | string;
    replacementIndex?: undefined | string;
};

interface IObjectTypeUnitCodesListState extends ObjectTypeUnit {
    isSubmitting: boolean;
    isShowPopup: boolean;
    searchName: string;
    items: ObjectTypeUnit[];
}

export class ObjectTypeUnitCodes extends Component<Record<string, unknown>, IObjectTypeUnitCodesListState> {
    constructor(props: Record<string, unknown>) {
        super(props);

        this.state = {
            isSubmitting: false,
            isShowPopup: false,
            searchName: '',
            items: [],
        };
    }

    public override async componentDidMount() {
        await this.search();
    }

    public override render() {
        return (
            <appContext.Consumer>
                {(appState) => (
                    <>
                        <TopbarLeftOnly>
                            <TopbarCrumbActive title={translateKeyLang(appState.languageCode, 'common.units')} icon="fa-cogs" />
                        </TopbarLeftOnly>
                        <Content>
                            <Tray>
                                <Panel>
                                    {(this.state.isSubmitting && <Spinner />) || (
                                        <PanelBody noPadding={true}>
                                            <Table>
                                                <TableHead>
                                                    <TableHeadRow light={true}>
                                                        <TableHeader>{translateKeyLang(appState.languageCode, 'common.name')}</TableHeader>
                                                        <TableHeader>Code</TableHeader>
                                                        <TableHeader>
                                                            {translateKeyLang(appState.languageCode, 'object.replacementIndex')}
                                                        </TableHeader>
                                                        <TableHeader>&nbsp;</TableHeader>
                                                    </TableHeadRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.items &&
                                                        this.state.items.map((item) => (
                                                            <TableRow key={item.id}>
                                                                <TableData>{item.name}</TableData>
                                                                <TableData>{item.code}</TableData>
                                                                <TableData>{item.replacementIndex}</TableData>
                                                                <TableData alignRight={true}>
                                                                    <PanelRouterLink
                                                                        to={`/settings/unitcodes/${item.id}/defaultmaintenance?unitname=${item.name}`}
                                                                        text={translateKeyLang(
                                                                            appState.languageCode,
                                                                            'maintenanceMeasure.maintenanceMeasures',
                                                                        )}
                                                                        xsmall
                                                                    />
                                                                    <PanelRouterLink
                                                                        to={`/settings/unitcodes/${item.id}/defaultfailuremode?unitname=${item.name}`}
                                                                        text={translateKeyLang(appState.languageCode, 'failureMode.failureModes')}
                                                                        xsmall
                                                                    />
                                                                    {appState.userRole === Roles.Administrator && (
                                                                        <IconEditButton onClick={() => this.handleUnitEditClicked(item.id!)} />
                                                                    )}
                                                                </TableData>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </PanelBody>
                                    )}

                                    {this.state.isShowPopup && (
                                        <>
                                            <PopupElement onClick={() => this.setState({ isShowPopup: false })}>
                                                <form method="post" action="/" id="admin-form" onSubmit={() => this.handleSaveUnit()}>
                                                    <PanelBodyHeading
                                                        text={translateKeyLang(
                                                            appState.languageCode,
                                                            'common.editItem',
                                                            translateKeyLang(appState.languageCode, 'common.unit'),
                                                        )}
                                                    >
                                                        <EditPanelSection>
                                                            <EditPanelInput
                                                                name="name"
                                                                placeholder={translateKeyLang(appState.languageCode, 'common.name')}
                                                                value={this.state.name}
                                                                icon="fa fa-pagelines"
                                                                handleChange={this.handleChange.bind(this)}
                                                            />
                                                        </EditPanelSection>
                                                        <EditPanelRow>
                                                            <EditPanelCell rowCount={4}>
                                                                <EditPanelInput
                                                                    name="code"
                                                                    placeholder={translateKeyLang(appState.languageCode, 'common.code')}
                                                                    value={this.state.code}
                                                                    restrictToNumbers={true}
                                                                    handleChange={this.handleChange.bind(this)}
                                                                />
                                                            </EditPanelCell>
                                                            <EditPanelCell rowCount={4}>
                                                                <EditPanelInput
                                                                    name="replacementIndex"
                                                                    placeholder={translateKeyLang(appState.languageCode, 'object.replacementIndex')}
                                                                    value={this.state.replacementIndex}
                                                                    restrictToNumbers={true}
                                                                    handleChange={this.handleChange.bind(this)}
                                                                />
                                                            </EditPanelCell>
                                                        </EditPanelRow>
                                                        <EditPanelButtons>
                                                            <EditPanelButton
                                                                onClick={() => this.setState({ isShowPopup: false })}
                                                                small={true}
                                                                text={translateKeyLang(appState.languageCode, 'common.cancel')}
                                                            />
                                                            <EditPanelButton
                                                                onClick={this.handleSaveUnit.bind(this)}
                                                                small={true}
                                                                primary={true}
                                                                disabled={this.state.isSubmitting}
                                                                text={translateKeyLang(
                                                                    appState.languageCode,
                                                                    'common.saveItem',
                                                                    translateKeyLang(appState.languageCode, 'common.unit'),
                                                                )}
                                                            />
                                                        </EditPanelButtons>
                                                    </PanelBodyHeading>
                                                </form>
                                            </PopupElement>
                                        </>
                                    )}
                                </Panel>
                            </Tray>
                            <RightTray>
                                <form
                                    id="filter"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="admin-form">
                                        <h4>
                                            {' '}
                                            {translateKeyLang(
                                                appState.languageCode,
                                                'common.findItem',
                                                translateKeyLang(appState.languageCode, 'common.unit'),
                                            )}
                                        </h4>
                                        <EditPanelSection>
                                            <EditPanelInput
                                                name="searchName"
                                                placeholder={translateKeyLang(appState.languageCode, 'common.name')}
                                                value={this.state.searchName}
                                                icon="fa fa-pagelines"
                                                handleChange={this.handleChange.bind(this)}
                                            />
                                        </EditPanelSection>
                                    </div>
                                </form>
                            </RightTray>
                        </Content>
                    </>
                )}
            </appContext.Consumer>
        );
    }

    private async search() {
        let url = '/api/objectTypeUnitCodes';
        if (this.state.searchName !== '') {
            url = `/api/objectTypeUnitCodes?name=${this.state.searchName}`;
        }
        await this.setState({ isSubmitting: true });
        const result = await fetchGet(url);
        await this.setState({ items: result.json, isSubmitting: false });
    }

    private handleChange(value: any, stateKey: string) {
        const newState = {} as any;
        newState[stateKey] = value;
        this.setState(newState);
        if (stateKey === 'searchName') {
            this.search();
        }
    }

    private handleUnitEditClicked(selectedId: string) {
        for (let i = 0; i < this.state.items.length; i++) {
            const item = this.state.items[i]!;

            if (item.id === selectedId) {
                this.setState({
                    isShowPopup: true,
                    id: item.id,
                    name: item.name,
                    code: item.code,
                    replacementIndex: item.replacementIndex,
                });
                break;
            }
        }
    }

    private async handleSaveUnit() {
        await this.setState({ isSubmitting: true });
        const data = {
            name: this.state.name,
            code: this.state.code,
            replacementIndex: this.state.replacementIndex,
        } as ObjectTypeUnit;

        const url = `/api/objectTypeUnitCodes/${this.state.id}`;
        await fetchPost(url, {}, data);
        await this.setState({ isShowPopup: false });
        await this.search();
    }
}
